/*
1) get all projects in-progress.
2) logic was changed so that everyone can read projects and see the dashboard.


Also: create a projectStatus hash in globalConstants to improve performance of decode function.

We are NOT navigating to the status report, so:
1) add a pushstate to mimic the movement.
2) we intersept the back button to close the status report if open.

*/

import { APP_BASE_HREF, formatDate, Location, PlatformLocation, ViewportScroller } from "@angular/common";
import { HttpParams } from '@angular/common/http';
import {
    OnInit,
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    Inject,
    Input
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BrowserUtils } from "@azure/msal-browser";
import { WorkRequestService } from "@app-services/work-request.service";
import {
    WorkRequest,
    IWorkRequestQueryOptions,
} from "@app-models/work-request";
import { DatePipe } from "@angular/common";
import {
    getCurrentUserFromStorage, getFilterFromStorage, setFilterInStorage, setPreviousViewInStorage, setScreenModeInStorage,

} from "@app/utils/storage-utils";
import { AzureUser } from "@app-models/azure-user";
import { AlertService } from "@app/modules/alert";
import { GlobalConstants } from "@app/utils/global-constants";
import { GlobalService } from "@app-services/global.services";
import { NgxSpinnerService } from "ngx-spinner";
import { SoModalService } from "@app/shared/so-modal/so-modal.service";
import { MenuCheckBoxOptions } from "@app/shared/so-menu-with-checkboxes/so-menu-with-checkboxes";


@Component({
    selector: "app-project-dashboard",
    templateUrl: "./project-dashboard.component.html",
    styleUrls: ["./project-dashboard.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ProjectDashboardComponent implements OnInit {
    @Input() inputDisplayMode: string; 

    //------------------------------------------
    // Constants
    //------------------------------------------
    infoMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: false,
    };
    errorMesageOptions = {
        autoClose: false,
        keepAfterRouteChange: true,
    };

    saveMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: true,
    };

    errorMessage = "message";

    DATE_FORMAT = "yyyy-MM-dd";
    DATE_TIME_FORMAT = "yyyy-MM-dd h:mm:ss a";

    projectStatuses = GlobalConstants.projectStatuses;
    projectStatusObj = GlobalConstants.projectStatusObj;

    projectStatusOptions: MenuCheckBoxOptions[] = [];
    projectStatusSelectedOptions: MenuCheckBoxOptions[] = [];
    
    projectTypes : any;
    projectTypeOptions: MenuCheckBoxOptions[] = [];
    projectTypeSelectedOptions: MenuCheckBoxOptions[] = [];
    
    portfolioValues : any;
    portfolioOptions: MenuCheckBoxOptions[] = [];
    portfolioSelectedOptions: MenuCheckBoxOptions[] = [];

    projectCategoryValues : any;
    projectCategoryOptions: MenuCheckBoxOptions[] = [];
    projectCategorySelectedOptions: MenuCheckBoxOptions[] = [];

    wrNumberValues : any;
    wrNumberOptions: MenuCheckBoxOptions[] = [];
    wrNumberSelectedOptions: MenuCheckBoxOptions[] = [];

    projectHeader= "Enterprise Technology Project Dashboard";
    dataRetrievalMode = GlobalConstants.REQUEST_FORM_MODE_PROJECT;
    displayMode = GlobalConstants.REQUEST_FORM_MODE_PROJECT;
    
    DISPLAY_MODE_PROJECT = GlobalConstants.REQUEST_FORM_MODE_PROJECT;
    DISPLAY_MODE_PROJECT_LIST = GlobalConstants.REQUEST_FORM_TITLE_PROJECT_LIST;
    

    //------------------------------------------
    //
    //------------------------------------------

    STORAGE_KEY = "dashboard_";
    FILTER_WR_NUMBER = "wr_number"
    FILTER_STATUS = 'project_status';
    FILTER_TYPE = 'project_type';
    FILTER_PORTFOLIO = 'portfolio';
    FILTER_PROJECT_CATEGORY = 'category';
    
    SORT_ORDER = 'sort_order'
    SORT_ORDER_DIRECTION = 'sort_order_direction'

    /*
    statusFormFilter: FormFilter = {
        name: this.FILTER_STATUS,
        label: "Project Status",
        options: [],
        searchCtrl: new FormControl(''),
        selectCtrl: new FormControl<string[]>([]),
        filteredOptions: new Observable<Record<string, string>[]>(),
    }
    */

    sortOrder = "projectTitle";
    sortOrderDirection = "asc"
    workRequest: WorkRequest = { projectStatus: "" }
    projectItLead = "";
    allWorkRequests : WorkRequest[] = [];
    filteredWorkRequests: WorkRequest[] = [];

    restrictedDashboard :  boolean = false;

    projectTypeCount: { [index: string]: any } = {};
    formError = "";
    systemDate: Date = new Date();
    currentUser: AzureUser;
    currentWorkRequest : WorkRequest;
    showStatusReport: boolean = false;
    showDashboard: boolean = true;
    queryParams: { [index: string]: any } = {};

    isInIframe: boolean = false;

    constructor(
        public datePipe: DatePipe,

        private workRequestService: WorkRequestService,
        private platformLocation: PlatformLocation,
        private globalService: GlobalService,
        private viewportScroller: ViewportScroller,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        protected soModalService: SoModalService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(APP_BASE_HREF) private baseHref:string
    ) {

    }

    //--------------------------
    // Life Cycle Events
    //--------------------------
    ngOnInit(): void {
        this.systemDate = this.globalService.getSystemDate();
        this.displayMode = GlobalConstants.REQUEST_FORM_MODE_PROJECT;
        this.route.data.subscribe(data => {
            if (data["mode"] === GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT) {
                this.projectHeader= "Enterprise Technology Restricted Project Dashboard";
                this.dataRetrievalMode = data["mode"];
                this.STORAGE_KEY = "restricted_dashboard_";
            }
            if (data["title"] === GlobalConstants.REQUEST_FORM_TITLE_PROJECT_LIST) {
                this.projectHeader= "Enterprise Technology Project List";
                this.dataRetrievalMode = data["mode"];
                this.displayMode = GlobalConstants.REQUEST_FORM_TITLE_PROJECT_LIST;
            } 
            
        })

        this.route.queryParams.subscribe((params) => {
            console.log(this.route.snapshot.queryParams);
            this.queryParams = this.route.snapshot.queryParams;
         });

        //If the displayMode is specified on the component, use over any routing settings.
        if (this.inputDisplayMode) {
            this.displayMode = this.inputDisplayMode;
            if (this.displayMode === GlobalConstants.REQUEST_FORM_TITLE_PROJECT_LIST) {
                this.projectHeader= "Enterprise Technology Project List";
            }
        }

        this.getProjectWorkRequests();
        this.currentUser = getCurrentUserFromStorage();
        this.viewportScroller.scrollToPosition([0, 0]);

        this.platformLocation.onPopState(() => {

            console.log('pressed back!');
            if (this.showStatusReport) {
                this.closeStatusReport(null, true);
            }

        });


        this.sortOrder = this.getFilterValueString(this.SORT_ORDER)||'projectTitle';
        this.sortOrderDirection = this.getFilterValueString(this.SORT_ORDER_DIRECTION)||'asc';


        if (BrowserUtils.isInIframe()) {
            this.isInIframe = true;
        }
 
    }


    getWRTooltip(rec: WorkRequest) {
        return rec.wrNumber + ": Last Updated: " + formatDate(rec.lastModifiedDateUTC!, "MMM dd, yyyy","en-US") + " by " + rec.lastModifiedUser + " - click to view request.";
    }
    getLastUpdate(rec: WorkRequest) {
        return "Last Updated: " + formatDate(rec.lastModifiedDateUTC!, "MMM dd, yyyy","en-US") + " (" + rec.lastModifiedUser + ")";
    }
    getProjectWorkRequests() {

        this.spinner.show();
        this.allWorkRequests = [];

        const pagingOpts = { pageNumber: 1, pageSize: 500, nextUrl: "" };
        const opts: IWorkRequestQueryOptions = {};

        opts.status = [GlobalConstants.STATUS_IN_PROGRESS];

        this.workRequestService.getProjects(this.dataRetrievalMode, pagingOpts, opts).subscribe({           
              next: (response: any) => {
                if (response === null) {
                    this.alertService.error(
                        "A problem occuring reading work requests",
                        this.errorMesageOptions
                    );
                    this.router.navigate(["/home"]);
                    this.spinner.hide();
                }
 
              
                for (const rec of response.data) {
                    rec.projectItLead = "";
                    rec.projectManager = "";
                    let leads = [];
                    let pms = [];
                    rec.keyUpdates = "";
                    for (const pr of rec.requestResources) {
                        if (pr.role === GlobalConstants.PROJECT_IT_LEAD_ROLE) {
                            leads.push(pr.name);
                        }
                        if (pr.role === GlobalConstants.PROJECT_MANAGER_ROLE) {
                            pms.push(pr.name);
                        }

                    }
                    rec.projectItLead = leads.join("<br/>");
                    rec.projectManager = pms.join("<br/>");

                    for (const pmm of rec.pmMilestones) {
                        if (pmm.showInReporting) {
                            rec.keyUpdates = rec.keyUpdates + pmm.description + "<br/>";
                        }
                    }
                    if (rec.keyUpdates.length > 1) {
                        rec.keyUpdates = rec.keyUpdates.slice(0, -5);
                    }

                    if (!rec.projectType) {
                        rec.projectType = GlobalConstants.PROJECT_TYPE_OTHER;
                    }


                    this.allWorkRequests.push(rec);

                }
                this.allWorkRequests.sort((a, b) => ((a.projectTitle||'') < (b.projectTitle||'') ? -1 : 1));
                //this.updateFilterState();

              
                this.setFilterValues();
                            
                this.redrawDashboard();
                
                this.spinner.hide();
            },
            error: () => {
                this.spinner.hide();
            }
        });
    }

    
    /**
     * 
     * @param rec 
     */
    goto(rec: WorkRequest) {
        setPreviousViewInStorage(this.router.url);
        setScreenModeInStorage(this.dataRetrievalMode);
        const route = "/work-request/" + rec.workRequestId;
        this.router.navigateByUrl(route, {});
    }

    /**
     * 
     * @param event 
     * @param rec 
     */
    gotoStatus(event: any, rec: WorkRequest) {
        /*
        setPreviousViewInStorage(this.router.url);
        const route = "/work-request/" + rec.workRequestId  + "/status";
        this.router.navigateByUrl(route, {});
        */
       setScreenModeInStorage(GlobalConstants.REQUEST_FORM_MODE_PROJECT);
       this.showDashboard = false;
       this.showStatusReport = true;
       this.currentWorkRequest = rec;
       this.platformLocation.pushState(null,this.baseHref + "work-request/" + rec.workRequestId  + "/status", this.baseHref + "work-request/" + rec.workRequestId  + "/status");
  
        if (this.isInIframe) {
            document.body.style.transform = "scale(" + this.globalService.statusReportScale + ")";
            document.body.style.transformOrigin = "top left";
        }
  
    }  

    getTooltip(rec: any, column: string) {
        return this.isInIframe ?  rec[column] : "";

    }

    scrollTo(target: string) {
        //this.scroller.scrollToAnchor("targetGreen");
        document.getElementById(target)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }

    /**
     * 
     * @param event 
     * @param isBrowserBackBtn 
     */
    closeStatusReport(event: any, isBrowserBackBtn?: boolean) {
        this.showDashboard = true;
        this.showStatusReport = false;

        if (this.isInIframe) {
            document.body.style.transform = "scale(" + this.globalService.iframeScale + ")";
            document.body.style.transformOrigin = "top left";
        }

 
        //if an application button, then we goback on the stack entry we created.
        if (!isBrowserBackBtn) {
            this.platformLocation.back()
        }

    }

    determineCounts() {
        this.projectTypeCount = {};
        for (let rec of this.filteredWorkRequests) {
            if (rec.projectType) {
                if (this.projectTypeCount[rec.projectType]) {
                    this.projectTypeCount[rec.projectType] = this.projectTypeCount[rec.projectType] + 1;
                } else {
                    this.projectTypeCount[rec.projectType] = 1;
                }
            }
        }
    }

    

    sortRecords(property: string, direction: string) {
        this.sortOrder = property;
        this.sortOrderDirection = direction;
        if (direction === 'desc') {
            this.filteredWorkRequests.sort((a, b) => ((a[property]||'') > (b[property]||'') ? -1 : 1));
        } else {
            this.filteredWorkRequests.sort((a, b) => ((a[property]||'') < (b[property]||'') ? -1 : 1));
        }
        this.setFilterValue(this.SORT_ORDER, this.sortOrder);
        this.setFilterValue(this.SORT_ORDER_DIRECTION, this.sortOrderDirection);

        this.setPushState();

    }

    //------------------------------------------
    //#region filter and push state
    //------------------------------------------
    public getFilterValueString(filter: string): string {
        //if there are any query parms, they override anything found in storage
        //once using this, this is unlikely.
        let retStr: string = "";
        if (this.queryParams[filter]) {
            retStr = this.queryParams[filter];
        } else {
            const selectVal = getFilterFromStorage(this.getStorageFilterKey(filter));
            if (selectVal) {
                retStr = selectVal.toString();
            }

        }
        return retStr;
    }

    public getFilterValue(filter: string): string[] {
        //if there are any query parms, they override anything found in storage
        //once using this, this is unlikely.
        let retStr: string[] = [];
        if (this.queryParams[filter]) {
            retStr = this.queryParams[filter].split(",");
        } else if (Object.keys(this.queryParams).length === 0) {

            const selectVal = getFilterFromStorage(this.getStorageFilterKey(filter));
            if (selectVal) {
                retStr = selectVal.toString().split(",");
            }
        }
        return retStr;
    }
    public setFilterValue(filter: string, value : string) {
        setFilterInStorage(this.getStorageFilterKey(filter),value);

    }
    /**
     * Set filter values. Most of these need to be set after the requests are retrieved (except status 
     * where we want all possible values (why?))
     */

    setFilterValues() {

        let filteredOptions : string[] = this.getFilterValue(this.FILTER_STATUS);
        this.projectStatusOptions = [];
        this.projectStatusSelectedOptions = [];
        for (let row of GlobalConstants.projectStatuses) {
            if (filteredOptions.find(opt => opt === row.key)) {
                this.projectStatusOptions.push({ title: row.value, activated: true, value: row.key });
                this.projectStatusSelectedOptions.push({ title: row.value, activated: true, value: row.key });
            } else {
                this.projectStatusOptions.push({ title: row.value, activated: false, value: row.key });
            }
        }

        this.projectTypes = [...new Set(this.allWorkRequests.map(item => item.projectType))];
        this.projectTypeOptions = [];
        this.projectTypeSelectedOptions = [];
        filteredOptions = this.getFilterValue(this.FILTER_TYPE);
        for (let row of this.projectTypes) {
            if (filteredOptions.find(opt => opt === row)) {
                this.projectTypeOptions.push({ title: row, activated: true, value: row });
                this.projectTypeSelectedOptions.push({ title: row, activated: true, value: row });
            } else {
                this.projectTypeOptions.push({ title: row, activated: false, value: row });
            }
        }
        this.portfolioValues = [...new Set(this.allWorkRequests.map(item => item.portfolio))];
        filteredOptions = this.getFilterValue(this.FILTER_PORTFOLIO);
        this.portfolioOptions = [];
        this.portfolioSelectedOptions = [];
        for (let row of this.portfolioValues) {
            if (row) {
                if (filteredOptions.find(opt => opt === row)) {
                    this.portfolioOptions.push({ title: row, activated: true, value: row });
                    this.portfolioSelectedOptions.push({ title: row, activated: true, value: row });
                } else {
                    this.portfolioOptions.push({ title: row, activated: false, value: row });
                }
            }
        }

        this.projectCategoryValues = [...new Set(this.allWorkRequests.map(item => item.projectCategory))];
        filteredOptions = this.getFilterValue(this.FILTER_PROJECT_CATEGORY);
        this.projectCategoryOptions = [];
        this.projectCategorySelectedOptions = [];
        for (let row of this.projectCategoryValues) {
            if (row) {
                if (filteredOptions.find(opt => opt === row)) {
                    this.projectCategoryOptions.push({ title: row, activated: true, value: row });
                    this.projectCategorySelectedOptions.push({ title: row, activated: true, value: row });
                } else {
                    this.projectCategoryOptions.push({ title: row, activated: false, value: row });
                }
            }
        }

        this.wrNumberValues = [...new Set(this.allWorkRequests.map( (item) => ({ wrNumber : item.wrNumber, projectTitle : item.projectTitle})))];
        filteredOptions = this.getFilterValue(this.FILTER_WR_NUMBER);
        this.wrNumberOptions = [];
        this.wrNumberSelectedOptions = [];
        for (let row of this.wrNumberValues) {
            if (row) {
                if (filteredOptions.find(opt => opt === row.wrNumber)) {
                    this.wrNumberOptions.push({ title: row.projectTitle, activated: true, value: row.wrNumber });
                    this.wrNumberSelectedOptions.push({ title: row.projectTitle, activated: true, value: row.wrNumber });
                } else {
                    this.wrNumberOptions.push({ title: row.projectTitle, activated: false, value: row.wrNumber });
                }
            }
        }

        this.setPushState();
    }

    public updateSelectedProjectStatuses(selectedOptions: MenuCheckBoxOptions[]) {
        this.projectStatusSelectedOptions = selectedOptions;
        this.redrawDashboard();
        this.setFilterValue(this.FILTER_STATUS, selectedOptions.map(s => s.value).join(','));
        this.setPushState();
    }

    public updateSelectedProjectTypes(selectedOptions: MenuCheckBoxOptions[]) {
        this.projectTypeSelectedOptions = selectedOptions;
        this.redrawDashboard();
        this.setFilterValue(this.FILTER_TYPE, selectedOptions.map(s => s.value).join(','));
        this.setPushState();

    }
    public updateSelectedPortfolio(selectedOptions: MenuCheckBoxOptions[]) {
        this.portfolioSelectedOptions = selectedOptions;
        this.redrawDashboard();
        this.setFilterValue(this.FILTER_PORTFOLIO, selectedOptions.map(s => s.value).join(','));
        this.setPushState();
    }   
    public updateSelectedProjectCategory(selectedOptions: MenuCheckBoxOptions[]) {
        this.projectCategorySelectedOptions = selectedOptions;
        this.redrawDashboard();
        this.setFilterValue(this.FILTER_PROJECT_CATEGORY, selectedOptions.map(s => s.value).join(','));
        this.setPushState();
    }  
    public updateSelectedWrNumbers(selectedOptions: MenuCheckBoxOptions[]) {
        this.wrNumberSelectedOptions = selectedOptions;
        this.redrawDashboard();
        this.setFilterValue(this.FILTER_WR_NUMBER, selectedOptions.map(s => s.value).join(','));
        this.setPushState();

    }
    getStorageFilterKey(key: string) : string {
        return this.STORAGE_KEY + key;
    }
    
    setPushState() {

        let params = new HttpParams();
        if (this.wrNumberSelectedOptions.length > 0) {
            params = params.append(this.FILTER_WR_NUMBER, this.wrNumberSelectedOptions.map(s => s.value).join(','));
        }
        if (this.projectTypeSelectedOptions.length > 0) {
            params = params.append(this.FILTER_TYPE, this.projectTypeSelectedOptions.map(s => s.value).join(','));
        }
        if (this.projectStatusSelectedOptions.length > 0) {
            params = params.append(this.FILTER_STATUS, this.projectStatusSelectedOptions.map(s => s.value).join(','));
        }
        if (this.portfolioSelectedOptions.length > 0) {
            params = params.append(this.FILTER_PORTFOLIO, this.portfolioSelectedOptions.map(s => s.value).join(','));
        }
        if (this.projectCategorySelectedOptions.length > 0) {
            params = params.append(this.FILTER_PROJECT_CATEGORY, this.projectCategorySelectedOptions.map(s => s.value).join(','));
        }
        if (this.sortOrder) {
            params = params.append(this.SORT_ORDER, this.sortOrder);
        }
        if (this.sortOrderDirection) {
            params = params.append(this.SORT_ORDER_DIRECTION, this.sortOrderDirection);
        }

        if (Object.keys(params).length > 0) {
            this.platformLocation.pushState(null,this.baseHref + location.pathname.replace(this.baseHref,""), this.baseHref +  location.pathname .replace(this.baseHref,"")+ "?" + params.toString());
        }
    }
    //#endregion
    redrawDashboard() {
        this.filteredWorkRequests = this.allWorkRequests;

        if (this.projectTypeSelectedOptions && this.projectTypeSelectedOptions.length > 0) {
            this.filteredWorkRequests = this.filteredWorkRequests.filter(item => (this.projectTypeSelectedOptions.find(s => s.value === item.projectType)));
        } 
        if (this.projectStatusSelectedOptions && this.projectStatusSelectedOptions.length > 0) {
            this.filteredWorkRequests = this.filteredWorkRequests.filter(item => (this.projectStatusSelectedOptions.find(s => s.value === item.projectStatus)));
        } 
        if (this.portfolioSelectedOptions && this.portfolioSelectedOptions.length > 0) {
            this.filteredWorkRequests = this.filteredWorkRequests.filter(item => (this.portfolioSelectedOptions.find(s => s.value === item.portfolio)));
        } 
        if (this.projectCategorySelectedOptions && this.projectCategorySelectedOptions.length > 0) {
            this.filteredWorkRequests = this.filteredWorkRequests.filter(item => (this.projectCategorySelectedOptions.find(s => s.value === item.projectCategory)));
        }   
        if (this.wrNumberSelectedOptions && this.wrNumberSelectedOptions.length > 0) {
            this.filteredWorkRequests = this.filteredWorkRequests.filter(item => (this.wrNumberSelectedOptions.find(s => s.value === item.wrNumber)));
        }                
        this.sortRecords(this.sortOrder, this.sortOrderDirection);
        this.projectTypes = [...new Set(this.filteredWorkRequests.map(item => item.projectType))].sort((a, b) => ((a || '') > (b || '') ? -1 : 1));
        this.determineCounts();
    }

    displaySortToolTip() {      
        return this.globalService.camelCaseToWords(this.sortOrder.replace("UTC","")) + " (" + this.sortOrderDirection + ")";
    }
}
